import * as React from 'react';
import { DragDropContextProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
export var Target = function Target(_ref) {
  var canDrop = _ref.canDrop,
      isOver = _ref.isOver,
      connectDropTarget = _ref.connectDropTarget,
      render = _ref.render;
  return React.createElement(DragDropContextProvider, {
    backend: HTML5Backend
  }, connectDropTarget(React.createElement("div", null, render({
    canDrop: canDrop,
    isOver: isOver
  }))));
};
export default Target;